import Axios from 'axios'
import Qs from 'qs'
import { BaseUrl } from '@/api/config'

// element 弹框
import { MessageBox } from 'element-ui'
// 路由 / vueX
import router from '@/router'
import store from '@/store'

/****** 创建axios实例 ******/
const request = Axios.create({
    baseURL: BaseUrl,  // api的base_url
    timeout: 50000  // 请求超时时间
});


/****** request拦截器==>对请求参数做处理 ******/
request.interceptors.request.use(config => {
    // 发送参数前进行处理。 这时候我们通过Qs.stringify转换为表单查询参数
    config.method === 'post'
        ? config.data = Qs.stringify({ ...config.data })
        : config.params = { ...config.params };
    // 设置Content - Type
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';

    return config;
}, error => {
    //请求错误处理
    Promise.reject(error)
});

/****** respone拦截器==>对响应做处理 ******/
request.interceptors.response.use(
    response => {
        //成功请求到数据
        //这里根据后端提供的数据进行对应的处理
        if (response.data.code === 1) {
            return response.data;
        } else if(response.data.code === 1003){
            if(!Object.keys(store.getters.get_userInfo).length ){
                return
            }
            // utoken错误或utoken过期
            MessageBox.alert(`请重新登录（${response.data.code}）`, '登录过期', {
                confirmButtonText: '确定',
                showClose: false,
                callback: () => {
                    // 清空 登录状态
                    store.commit({
                        type: 'set_userInfo',
                        data:{}
                    });
                    // 路由跳转至 登录页面
                    router.push({path: '/login'});
                },
            });
        } else {
            // 提示错误
            MessageBox.alert(`${response.data.msg}（${response.data.code}）`, '错误', {
                confirmButtonText: '确定',
                showClose: false,
                callback: () => {
                    // 请求超时
                    // sign签名错误
                    // 重复请求
                },
            });
            return response.data;
        }
    },
    error => {  //响应错误处理
        MessageBox.alert(`${error}`, '错误', {
            confirmButtonText: '确定',
            showClose: false,
            callback: () => {
                // 请求超时
                // sign签名错误
                // 重复请求
            }
        })
        let errObj=JSON.parse(JSON.stringify(error))
        if(errObj.response.status==404){
            router.push({
                path: '/error',
                query:{
                    id:404
                }
            });
        }else if(errObj.response.status==500){
            router.push({
                path: '/error',
                query:{
                    id:500
                }
            });
        }
        return Promise.reject(error)
    }
);

export default request;
